{
  "title": "위치 접근을 허용하시겠습니까?",
  "body": "위치 접근을 허용하면 체크인을 위해 시설에 도착했는지 확인할 수 있습니다",
  "disagree": "거부",
  "agree": "동의"
}
